import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'

function memberInitials(member) {
    const label = member?.full_name || member?.email || ''
    return label
        .trim()
        .split(/\s+/)
        .slice(0, 2)
        .map((part) => part[0]?.toUpperCase())
        .join('') || '?'
}

function memberColor(member) {
    const source = String(member?.id || member?.full_name || member?.email || '')
    const hue = [...source].reduce((value, character) => value + character.charCodeAt(0), 0) % 360
    return `hsl(${hue}, 50%, 40%)`
}

export default function MemberSearchDropdown({ members, onSelect, onClose }) {
    const { t } = useTranslation()
    const [search, setSearch] = useState('')
    const ref = useRef(null)
    const inputRef = useRef(null)

    useEffect(() => {
        inputRef.current?.focus()
        const handleClickOutside = (e) => {
            if (ref.current && !ref.current.contains(e.target)) onClose()
        }
        document.addEventListener('mousedown', handleClickOutside)
        return () => document.removeEventListener('mousedown', handleClickOutside)
    }, [onClose])

    const filtered = members.filter(m => {
        const name = (m.full_name || m.email || '').toLowerCase()
        return name.includes(search.toLowerCase())
    })

    return (
        <div className="member-search-dropdown" ref={ref}>
            <input
                ref={inputRef}
                className="inline-input"
                placeholder={t('sharedMemberPicker.searchPlaceholder')}
                value={search}
                onChange={e => setSearch(e.target.value)}
                onKeyDown={e => e.key === 'Escape' && onClose()}
            />
            <div className="member-search-list">
                {filtered.map(m => (
                    <button
                        key={m.id}
                        type="button"
                        className="member-search-item"
                        onMouseDown={(e) => { e.preventDefault(); onSelect(m.id) }}
                    >
                        <span
                            className="member-search-avatar"
                            style={{ background: memberColor(m) }}
                            aria-hidden="true"
                        >
                            {memberInitials(m)}
                        </span>
                        <span className="member-search-name">
                            {m.full_name || m.email || t('sharedMemberPicker.userFallback')}
                        </span>
                    </button>
                ))}
                {filtered.length === 0 && <div className="member-search-empty">{t('sharedMemberPicker.empty')}</div>}
            </div>
            <button className="btn btn-secondary btn-sm cd-cancel-inline" onClick={onClose}>{t('common.cancel')}</button>
        </div>
    )
}
